import { lazy, Suspense, useEffect } from 'react';

/// Components
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import { Route, Routes, useLocation, useNavigate, useParams, Navigate } from 'react-router-dom';
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import { jwtDecode } from 'jwt-decode'
import { toast } from 'react-toastify';
import { restoreAuthState, initTabSession } from './services/AuthService';
import SessionMaintainer from './jsx/components/SessionMaintainer';

// Session management functions removed - using localStorage for tab persistence



function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}



function App(props) {
  const dispatch = useDispatch();

  // Session maintenance is now handled by SessionMaintainer component
  useEffect(() => {
    initTabSession();
    restoreAuthState(dispatch);
  }, []);

  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === 'logout') {
        // Clear subscription caches
        try {
          const { clearDocumentSubscriptionCache } = require('./utils/documentAccess');
          const { clearSubscriptionCache } = require('./utils/featureLock');
          clearDocumentSubscriptionCache();
          clearSubscriptionCache();
        } catch (err) {
          console.error('Error clearing subscription caches:', err);
        }
        
        // Clear all authentication data
        localStorage.removeItem('accessToken');
        localStorage.removeItem('tempAccessToken');
        localStorage.removeItem('user');
        localStorage.removeItem('userDetails');
        localStorage.removeItem('rememberMe');
        localStorage.removeItem('userPlanFeatures'); // Clear user plan features
        localStorage.removeItem('tabCount');
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('isFirstSession');
        sessionStorage.removeItem('redirectAfterLogin'); // Clear stored redirect page

        // Show notification to user
        toast.info('You have been logged out from another session', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Redirect to login page on logout from another tab
        if (props.router && props.router.navigate) {
          props.router.navigate('/login');
        }
      } else if (event.key === 'tabOpened') {
        // A new tab was opened, sync session if needed
        const rememberMe = localStorage.getItem('rememberMe') === 'true';
        if (!rememberMe) {
          const tempToken = localStorage.getItem('tempAccessToken');
          const user = localStorage.getItem('user');
          const currentSessionToken = sessionStorage.getItem('accessToken');

          if (tempToken && user && !currentSessionToken) {
            // This tab doesn't have a session token but there's a temp token available
            sessionStorage.setItem('accessToken', tempToken);
            console.log('Session synced from new tab event');
          }
        }
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => {
      window.removeEventListener('storage', handleStorage);
    };
  }, [props.router]);

  useEffect(() => {
    const validateToken = () => {
      const rememberMe = localStorage.getItem("rememberMe") === "true";
      let accessToken = null;

      if (rememberMe) {
        accessToken = localStorage.getItem("accessToken");
      } else {
        accessToken = localStorage.getItem("tempAccessToken");
      }

      if (accessToken) {
        try {
          const parsedToken = JSON.parse(accessToken);
          const decoded = jwtDecode(parsedToken);
          if (decoded.exp * 1000 <= Date.now()) {
            // Token is expired, clear all token storage
            console.log("Token expired, clearing authentication data");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("tempAccessToken");
            localStorage.removeItem("tabCount");
            sessionStorage.removeItem("accessToken");
            sessionStorage.removeItem("isFirstSession");
            localStorage.removeItem("rememberMe");
            localStorage.removeItem("user");
            localStorage.removeItem("userDetails");
          }
          // If token is valid, do nothing - keep user logged in
        } catch (e) {
          // Only clear if there's a parsing error, not for other issues
          console.error("Error parsing token:", e);
          // Don't clear data for parsing errors during navigation
        }
      }
    };

    // Only validate token once on app load, not on every navigation
    // validateToken();
  }, []); // Empty dependency array ensures this only runs once
  // Session tab management removed - using localStorage for tab persistence

  return (
    <Suspense fallback={
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    }>
      <Routes>
        {/* All other routes go to the main app (Index), which should handle private/protected routes */}
        <Route path="/*" element={<Index />} />
      </Routes>
    </Suspense>
  );
}


const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

//export default connect((mapStateToProps)(App)); 
export default withRouter(connect(mapStateToProps)(App)); 